import { render } from "./ExportAnnotations.vue?vue&type=template&id=234ebefe&bindings={\"generateJSONExport\":\"options\"}"
import script from "./ExportAnnotations.vue?vue&type=script&lang=js"
export * from "./ExportAnnotations.vue?vue&type=script&lang=js"
script.render = render

export default script
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QItemSection});qInstall(script, 'directives', {ClosePopup});
